import { __decorate } from "tslib";
import { Mixins, Component, Prop } from 'vue-property-decorator';
import ApplicationStatusActionMixin from '@/helpers/vue_mixins/v2/b2b/ApplicationStatusActionMixin';
import ActionButton from '@/components/action_button/Index.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
import { successfulUpdate } from '@/helpers/mixins/LocalizationHelper';
import { PartnershipApplicationStatus } from '@/helpers/entities/enums/v2/PartnershipApplicationStatus';
import ApplicationReject from '@/plugins/graphql/mutations/v2/b2b/partnership-application-reject.gql';
import ApplicationByStatusQuery from '@/plugins/graphql/queries/v2/b2b/partnership-applications-by-status.gql';
import FormMixin from '@/helpers/vue_mixins/FormMixin';
import FormValidationsMixin from '@/helpers/vue_mixins/v2/FormValidationsMixin';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import { required } from 'vuelidate/lib/validators';
let RejectApplication = class RejectApplication extends Mixins(ViewportSizeMixin, ApplicationStatusActionMixin, FormMixin, FormValidationsMixin) {
    constructor() {
        super(...arguments);
        this.form = {
            declineMessage: null,
        };
    }
    uponReject() {
        this.$v.$touch();
        if (!this.$v.$invalid) {
            this.reject(this.form);
        }
    }
    async reject(form) {
        this.requestOnFlight();
        await this.update(form)
            .then(() => {
            const msg = successfulUpdate('Application Rejected');
            this.successNotification(msg);
            this.$router.push({
                name: 'applications-by-status',
                params: { status: 'rejected' },
            });
        })
            .catch((e) => {
            this.errorNotification(e.message);
        })
            .finally(() => {
            this.requestDone();
        });
    }
    async update(form) {
        const { declineMessage } = form;
        const currentStatus = PartnershipApplicationStatus.Rejected;
        const prevStatus = this.status;
        const appUuid = this.appUUID;
        const vm = this;
        return this.$apollo.mutate({
            mutation: ApplicationReject,
            variables: {
                input: {
                    applicationUuid: vm.applicationUuid,
                    declineMessage,
                },
            },
            update(cache, { data }) {
                const updatedApplication = data.partnershipApplicationReject.application;
                vm.updateApplicationStatusCache(prevStatus, currentStatus, updatedApplication, vm.applicationUuid, appUuid, cache);
            },
            refetchQueries: [
                {
                    query: ApplicationByStatusQuery,
                    variables: {
                        appUuid,
                        status: prevStatus,
                    },
                },
            ],
        });
    }
};
__decorate([
    Prop({ type: String })
], RejectApplication.prototype, "status", void 0);
RejectApplication = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
        },
        validations: {
            form: {
                declineMessage: {
                    required,
                },
            },
        },
    })
], RejectApplication);
export default RejectApplication;
